
import React, {
  // useContext,
  useState,
} from 'react'

import config from 'config'

import { BanksCtx } from '$src/components/banks'
import { PeriodsCtx } from '$src/components/periods'
import { AppCtx } from '../App'

import {
  C,
  logg, loggt,
} from './'

const useApiRouter = () => {

  const {
    jwtToken,
  } = React.useContext(AppCtx)
  // logg(jwtToken, 'jwtToken in apiRouter')

  const {
    selectedBanks = {},
    sortedResults = [],
  } = React.useContext(BanksCtx)
  // loggt(React.useContext(BanksCtx), 'BanksCtx in apiRouter')
  const selectedRssds  = Object.keys(selectedBanks)
  const selectedRssds_ = sortedResults.filter((a, idx) => selectedRssds.indexOf(`${a.rssd}`) >= 0).map((a, idx) => a.rssd).join(',')

  const {
    selectedPeriods = {},
    selectedPeriodsReverse,
  } = React.useContext(PeriodsCtx)
  const selectedPeriodsStr = Object.keys(selectedPeriods).join(',')

  const apiRouter = {
    acceptEulaPath: ({jwt_token: jwtToken }) => {
      return `${config.apiOrigin}/user/accept-eula.json?jwt_token=${jwtToken}`
    },
    advancedReportClonePath: ({ id }) => `${config.apiOrigin}/advanced_reports/clone/${id}.json?jwt_token=${jwtToken}`,
    advancedReportPath:      ({ id }) => `${config.apiOrigin}/advanced_reports/${id}.json?jwt_token=${jwtToken}`,
    advancedReportRunPath:   ({ id, format='csv', ...props }) => {
      const propsStr = Object.keys(props).map((k) => `${k}=${props[k]}`).join("&")
      // return `${config.apiOrigin}/advanced_reports/${id}/run.${format}?rssds=${selectedRssds_}&jwt_token=${jwtToken}&${propsStr}`
      return `${config.apiOrigin}/advanced_reports/${id}/run.${format}?jwt_token=${jwtToken}&${propsStr}`
    },
    advancedReportsPath: () => `${config.apiOrigin}/advanced_reports.json?jwt_token=${jwtToken}`,

    bankContactsPath:     ({ rssd, format='json' }) => `${config.apiOrigin}/banks/${rssd}/contacts.${format}?jwt_token=${jwtToken}`,
    bankPath:             ({ rssd                }) => `${config.apiOrigin}/banks/by-rssd/${rssd}.json?jwt_token=${jwtToken}`,
    bankSchedulePlotPath: ({ rssd, schedule_id   }) => `${config.apiOrigin}/banks/${rssd}/schedules/${schedule_id}/plot.json`,

    banksPath: () => `${config.apiOrigin}/banks.json`,
    bankSchedulePath: (props) => {
      const { rssd, schedule_id, format = 'json' } = props
      return `${config.apiOrigin}/banks/${rssd}/schedules/${schedule_id}/periods/${selectedPeriodsStr}.${format}?periods_reverse=${selectedPeriodsReverse}&jwt_token=${jwtToken}`
    },

    charterAuthoritiesPath: ({ jwtToken, }) => `${config.apiOrigin}/charter_authorities.json?jwt_token=${jwtToken}`,
    charterTypesPath: ({ jwtToken, }) => `${config.apiOrigin}/charter_types.json?jwt_token=${jwtToken}`,

    docsPath: ( code = 'ORGPROF' ) => `${config.apiOrigin}/docs/view/${code}?jwt_token=${jwtToken}`,
    docsSearchPath: (q) => `${config.apiOrigin}/docs/search/${q}?jwt_token=${jwtToken}`,

    fintechsPath: () => `${config.apiOrigin}/finteches.json`,
    fintegrationOptsPath: () => `${config.apiOrigin}/fintegration/opts.json?jwt_token=${jwtToken}`,
    fintegrationRunPath:  ({ format = 'json' }) => `${config.apiOrigin}/fintegration/run.${format}?jwt_token=${jwtToken}`,

    querySchedulePath: ({ query_id, schedule_id }) => `${config.apiOrigin}/queries/${query_id}/schedules/${schedule_id}.json`,


    listActionPath: (props) => {
      // logg(props, 'listActionPath')
      const { action, id } = props
      if (C.lists_actions.add_to_existing === action) {
        return `${config.apiOrigin}/lists/add-to/${id}.json?jwt_token=${jwtToken}`
      }
      if (C.lists_actions.remove_from_existing === action) {
        return `${config.apiOrigin}/lists/remove-from/${id}.json?jwt_token=${jwtToken}`
      }
    },
    listImportPath: () => `${config.apiOrigin}/lists/import.json?jwt_token=${jwtToken}`,

    listsPath:      () => `${config.apiOrigin}/lists.json?jwt_token=${jwtToken}`,

    msasListPath: ({ jwtToken, }) => `${config.apiOrigin}/msas.json?jwt_token=${jwtToken}`,
    // only for adding-to, removing-from
    myListsPath: () => `${config.apiOrigin}/lists/mine.json?jwt_token=${jwtToken}`,

    periodsPath: () => `${config.apiOrigin}/periods.json?jwt_token=${jwtToken}`,

    queryClonePath:  ({ id }) => `${config.apiOrigin}/queries/clone/${id}.json?jwt_token=${jwtToken}`,
    queryPath:       ({ id }) => `${config.apiOrigin}/queries/${id}.json?jwt_token=${jwtToken}`,
    queryRenamePath: ({ id }) => `${config.apiOrigin}/queries/rename/${id}.json?jwt_token=${jwtToken}`,
    queryRunPath:    ()       => `${config.apiOrigin}/queries/run.json?jwt_token=${jwtToken}`,
    queriesPath:     ()       => `${config.apiOrigin}/queries.json?jwt_token=${jwtToken}`,
    queriesRunPath:  (ids)    => `${config.apiOrigin}/queries/run/${ids}.json?jwt_token=${jwtToken}`,

    reportPath:       ({ id }) => `${config.apiOrigin}/reports/${id}.json?jwt_token=${jwtToken}`,
    reportClonePath:  ({ id }) => `${config.apiOrigin}/reports/clone/${id}.json?jwt_token=${jwtToken}`,
    reportRenamePath: ({ id }) => `${config.apiOrigin}/reports/rename/${id}.json?jwt_token=${jwtToken}`,
    reportRunPath: ({ id, format='csv', ...props }) => {
      // logg(props, 'reportRunPath')
      const propsStr = Object.keys(props).map((k) => `${k}=${props[k]}`).join("&")
      return `${config.apiOrigin}/reports/${id}/run.${format}?periods=${selectedPeriodsStr}&periods_reverse=${selectedPeriodsReverse}&jwt_token=${jwtToken}&${propsStr}`
    },
    reportsPath:         () => `${config.apiOrigin}/reports.json?jwt_token=${jwtToken}`,
    resourcePath: (props) => { // for deleting!, what else?
      logg(props, 'apiRouter.resourcePath')
      const { kind, id } = props

      switch (kind) {
        case C.kinds.AdvancedReport_financials:
        case C.kinds.AdvancedReport_fintegration:
          return `${config.apiOrigin}/advanced_reports/${id}.json?jwt_token=${jwtToken}`

        case C.kinds.Report:
          return `${config.apiOrigin}/reports/${id}.json?jwt_token=${jwtToken}`

        case C.kinds.Query:
        case C.kinds.List:
          return `${config.apiOrigin}/queries/${id}.json?jwt_token=${jwtToken}`

        default:
          throw '06r - this should not happen'
      }
    },
    resourceSharePath: () => {
      return `${config.apiOrigin}/resource/share.json?jwt_token=${jwtToken}`
    },
    resourceSharedPath: ({id, kind }) => {
      return `${config.apiOrigin}/resource/shared/id/${id}/kind/${kind}.json?jwt_token=${jwtToken}`
    },


    schedulesPath: () => `${config.apiOrigin}/schedules.json?jwt_token=${jwtToken}`,
    statesListPath: ({ jwtToken, }) => `${config.apiOrigin}/states.json?jwt_token=${jwtToken}`,
    subfunctionsPath: () => `${config.apiOrigin}/subfunctions.json`,

    tradingTypesPath: ({ jwtToken, }) => `${config.apiOrigin}/trading_types.json?jwt_token=${jwtToken}`,

    ubprCodesPath: (props = {}) => {
      const { schedule_id } = props
      if (schedule_id) {
        return `${config.apiOrigin}/schedules/${schedule_id}/ubpr_codes.json?jwt_token=${jwtToken}`
      } else {
        return `${config.apiOrigin}/ubpr_codes.json?jwt_token=${jwtToken}`
      }
    },

    updateQuery: ({ id, query }) => {
      logg([id, query], 'apiRouter UpdateQuery')

      return fetch(`${config.apiOrigin}/queries/${id}.json?jwt_token=${jwtToken}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ query, }),
      }).then(r => r.json())
    },

    userPath: ({ jwtToken }) => {
      return `${config.apiOrigin}/user.json?jwt_token=${jwtToken}`
    },

  }
  return apiRouter
}

export default useApiRouter
export {
  useApiRouter,
}
